import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { reduxForm } from "redux-form/immutable"

import UserInfoFormSection from "QuorumGrassroots/widgets/ReusableComponents/UserInfoFormSection/index"
import { StyledButton } from "QuorumGrassroots/styled-components/components/StyledButton"
import { StyledHorizontalRule } from "QuorumGrassroots/styled-components/components/StyledHorizontalRule"
import { PacUserInfoSection } from "QuorumGrassroots/widgets/UpdateInformation/components/PacUserInfoSection"

import { updateInformation } from "QuorumGrassroots/widgets/action-creators"
import { selectUserInitialValues } from "QuorumGrassroots/widgets/UpdateInformation/selectors"
import {
    selectIsPacEligible,
    selectHasPacCharitableMatch,
    selectTooltipText,
    selectReadOnlyFormFields,
    selectCustomFields,
} from "QuorumGrassroots/framework/selectors"
import { selectPACCharityMatchInfo } from "QuorumGrassroots/widgets/UpdateInformation/selectors"

export class SupporterUpdateComponent extends Component {
    static propTypes = {
        onBackClick: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
        isCampaignPage: PropTypes.bool,
        handleSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool,
        registrationPageIds: PropTypes.array,
        additionalSimpleFields: PropTypes.array,
        campaign: PropTypes.object,
        uniqueWidgetId: PropTypes.string,
        initialValues: PropTypes.object,
        isUserPacEligible: PropTypes.bool,
        hasPacCharitableMatch: PropTypes.bool,
        pacCharitableMatchInfo: PropTypes.object,
        tooltipText: PropTypes.string,
        readOnlyFields: PropTypes.array,
        change: PropTypes.func,
    }

    static defaultProps = {
        isCampaignPage: false,
        registrationPageIds: [],
        additionalSimpleFields: [],
        isUserPacEligible: false,
        hasPacCharitableMatch: false,
        pacCharitableMatchInfo: {},
        readOnlyFields: [],
    }

    render() {
        const { t, isCampaignPage, submitting, onBackClick } = this.props

        return (
            <div className="supporter-update-component">
                <form onSubmit={this.props.handleSubmit}>
                    <UserInfoFormSection
                        isCampaignPage={isCampaignPage}
                        registrationPageIds={this.props.registrationPageIds}
                        additionalSimpleFields={this.props.additionalSimpleFields}
                        uniqueWidgetId={this.props.uniqueWidgetId}
                        campaign={this.props.campaign}
                        showOnlyFilledCustomFields={false}
                        showOnlyUnfilledFields={false}
                        requireAllFields={true}
                        tooltipText={this.props.tooltipText}
                        readOnlyFields={this.props.readOnlyFields}
                        t={t}
                    />

                    {this.props.isUserPacEligible && this.props.hasPacCharitableMatch && (
                        <PacUserInfoSection
                            change={this.props.change}
                            initialValues={this.props.initialValues}
                            charitableMatchInfo={this.props.pacCharitableMatchInfo}
                        />
                    )}

                    <StyledHorizontalRule isCampaignPage={isCampaignPage} />

                    <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                        <StyledButton
                            isCampaignPage={isCampaignPage}
                            activateNGGTheme
                            disabled={submitting}
                            type="submit"
                            data-cy="submit-update-button"
                        >
                            {submitting ? t("form.submitting") : t("form.submit_form")}
                        </StyledButton>
                    </div>
                </form>
            </div>
        )
    }
}

const submit = (values, dispatch, props) => {
    return dispatch(updateInformation(values, props))
        .then((response) => {
            if (props.onBackClick) {
                props.onBackClick()
            }
            return response
        })
        .catch((error) => {
            console.error("SupporterUpdateComponent submit error:", error)
            throw error
        })
}

const ReduxFormSupporterUpdate = reduxForm({
    form: "supporterUpdate",
    onSubmit: submit,
    touchOnChange: true,
})(SupporterUpdateComponent)

const mapStateToProps = (state, ownProps) => ({
    initialValues: selectUserInitialValues(state, ownProps),
    isUserPacEligible: selectIsPacEligible(state),
    hasPacCharitableMatch: selectHasPacCharitableMatch(state),
    pacCharitableMatchInfo: selectPACCharityMatchInfo(state),
    tooltipText: selectTooltipText(state),
    readOnlyFields: selectReadOnlyFormFields(state),
    customFields: selectCustomFields(state),
})

const ConnectedSupporterUpdateComponent = connect(mapStateToProps)(ReduxFormSupporterUpdate)

export default ConnectedSupporterUpdateComponent
